import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TrackingPlanificacionComponent } from './view/tracking-planificacion/tracking-planificacion.component';
import { AuthGuard } from '../../shared-module/seguridad/services/auth.guard';
import { CheckGaritaComponent } from './view/check-garita/check-garita.component';
import { CheckVehicularComponent } from './view/check-vehicular/check-vehicular.component';
import { TrackingAndenComponent } from './view/tracking-anden/tracking-anden.component';
import { TrackingDocumentosComponent } from './view/tracking-documentos/tracking-documentos.component';
import { TrackingConvoyComponent } from './view/tracking-convoy/tracking-convoy.component';
//T.32832 - Import del componente tracking-adm
import { TrackingAdmComponent } from './view/tracking-adm/tracking-adm.component';
import { TrackingCamionComponent } from './view/tracking-camion/tracking-camion.component';
import { TipoPlanificacionComponent } from './view/tipo-planificacion/tipo-planificacion.component';
import { AreasLogisticaComponent } from './view/areas-logistica/areas-logistica.component';
import { ReporteBitacoraComponent } from './view/reporte-bitacora/reporte-bitacora.component';
import { ViewAlldocComponent } from './view/view-alldoc/view-alldoc.component';
import { MarquesinasComponent } from './view/marquesinas/marquesinas.component';
import { MarquesinaMensajesComponent } from './view/marquesina-mensajes/marquesina-mensajes.component';
import { ConfiguracionGeneralComponent } from './view/configuracion-general/configuracion-general.component';
import { EditarViajeComponent } from './view/editar-viaje/editar-viaje.component';
import { CancelarViajeComponent } from './view/cancelar-viaje/cancelar-viaje.component';
import { TrackingConvoyCierreComponent } from './view/tracking-convoy-cierre/tracking-convoy-cierre.component';
import { UploadCsvPlanificacionComponent } from './view/upload-csv-planificacion/upload-csv-planificacion.component';
import { CheckGaritaSalidaComponent } from './view/check-garita-salida/check-garita-salida.component';
import { LogPedidoDepuraComponent } from './view/log-pedido-depura/log-pedido-depura.component';

const routes: Routes = [
  { path: 'logistica/planificacion', component: TrackingPlanificacionComponent, canActivate: [AuthGuard]},
  { path: 'logistica/planificacion/:proceso', component: TrackingPlanificacionComponent, canActivate: [AuthGuard]},
  { path: 'logistica/editar-viaje', component: EditarViajeComponent, canActivate: [AuthGuard]},
  { path: 'logistica/cancelar-viaje', component: CancelarViajeComponent, canActivate: [AuthGuard]},
  
  { path: 'logistica/check-garita', component: CheckGaritaComponent, canActivate: [AuthGuard]},
  { path: 'logistica/check-garita/:aprobar', component: CheckGaritaComponent, canActivate: [AuthGuard]},
  { path: 'logistica/check-vehicular', component: CheckVehicularComponent, canActivate: [AuthGuard]},

  { path: 'logistica/andenes', component: TrackingAndenComponent, canActivate: [AuthGuard]},
  { path: 'logistica/andenes/:proceso', component: TrackingAndenComponent, canActivate: [AuthGuard]},
  { path: 'logistica/documentos', component: TrackingDocumentosComponent, canActivate: [AuthGuard]},

  { path: 'logistica/convoy', component: TrackingConvoyComponent, canActivate: [AuthGuard]},
  { path: 'logistica/bitacora', component: ReporteBitacoraComponent, canActivate: [AuthGuard]},

  //MEJORAS BALANZA
  { path: 'logistica/tipos-planificacion', component: TipoPlanificacionComponent, canActivate: [AuthGuard]},
  { path: 'logistica/areas-logisticas', component: AreasLogisticaComponent, canActivate: [AuthGuard]},

  //T.32832 - Ruta para tracking administrativo
  { path: 'logistica/tracking-adm', component: TrackingAdmComponent, canActivate: [AuthGuard]},
  { path: 'logistica/tracking-camion', component: TrackingCamionComponent, canActivate: [AuthGuard]},

  //ALCANCES SIN TICKET
  { path: 'logistica/print', component: ViewAlldocComponent, canActivate: [AuthGuard]},
  { path: 'logistica/marquesinas', component: MarquesinasComponent, canActivate: [AuthGuard]}, 
  { path: 'logistica/maquesinas-mensajes', component: MarquesinaMensajesComponent, canActivate: [AuthGuard]},
  { path: 'logistica/configuracion-general', component: ConfiguracionGeneralComponent, canActivate: [AuthGuard]},

  //Feat T.42031 Mod Logistica, 7.3 sesion de cierre
  { path: 'logistica/convoy/cierre', component: TrackingConvoyCierreComponent, canActivate: [AuthGuard]},
  //Feat T.42031 Mod Logistica, 9.1 sesion de cargar
  { path: 'logistica/planificacion-carga', component: UploadCsvPlanificacionComponent, canActivate: [AuthGuard]},
  //Check Garita Salida
  { path: 'logistica/check-garita-salida', component: CheckGaritaSalidaComponent, canActivate: [AuthGuard]},
  //Depuración de pedidos - Matriz de consecuencias
  { path: 'logistica/depuracion-pedidos', component: LogPedidoDepuraComponent, canActivate: [AuthGuard]},
];

//logistica/check-garita/aprobar

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class LogisticaRoutingModule { }
